module.exports = __webpack_public_path__ + "assets/img/mecha-btn-6715dba7.png";